"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExtensionsWithTrait = exports.getExtensions = exports.getExtension = exports.isKnownAddress = exports.hasTrait = exports.is1155 = exports.is721 = exports.addresses = exports.StorageProtocol = exports.Trait = exports.CLAIM_UPDATABLE_MINT_FEE_1155_V1 = exports.CLAIM_UPDATABLE_MINT_FEE_721_V1 = exports.CLAIM_EXTENSION_1155_V8 = exports.CLAIM_EXTENSION_721_V8 = exports.CLAIM_EXTENSION_1155_V7 = exports.CLAIM_EXTENSION_721_V7 = exports.CLAIM_EXTENSION_1155_SIGNATURE_MINTING_V1 = exports.CLAIM_EXTENSION_721_SIGNATURE_MINTING_V1 = exports.CLAIM_EXTENSION_1155_V6 = exports.CLAIM_EXTENSION_721_V6 = exports.CLAIM_EXTENSION_1155_V5_MAINNET = exports.CLAIM_EXTENSION_721_V5_MAINNET = exports.CLAIM_EXTENSION_1155_V4_MAINNET = exports.CLAIM_EXTENSION_721_V4_MAINNET = exports.CLAIM_EXTENSION_1155_V3_MAINNET = exports.CLAIM_EXTENSION_721_V3_MAINNET = exports.CLAIM_EXTENSION_1155_V2_MAINNET = exports.CLAIM_EXTENSION_721_V2_MAINNET = exports.CLAIM_EXTENSION_1155_V1_MAINNET = exports.CLAIM_EXTENSION_721_V1_MAINNET = exports.FEE_PER_MERKLE_MINT = exports.FEE_PER_MINT = void 0;
const ethers_1 = require("ethers");
const frontend_provider_types_1 = require("@manifoldxyz/frontend-provider-types");
const abis_1 = require("./abis");
const factories_1 = require("./contracts/ethers/factories");
exports.FEE_PER_MINT = ethers_1.BigNumber.from('420000000000000'); // 0.00042 ETH * 1e18;
exports.FEE_PER_MERKLE_MINT = ethers_1.BigNumber.from('690000000000000'); // 0.00069 ETH * 1e18;
exports.CLAIM_EXTENSION_721_V1_MAINNET = '0xb08aa31cc2b8c0582be42d38bb643292e0a4b9eb';
exports.CLAIM_EXTENSION_1155_V1_MAINNET = '0xca71c5270eff44eb6d813a92c0ba12577bddf208';
exports.CLAIM_EXTENSION_721_V2_MAINNET = '0x5ebfd58c5ead1025755f7490e510ccf2c0b4a444';
exports.CLAIM_EXTENSION_1155_V2_MAINNET = '0x4e32004d8b81847a670b4a1778ace4dcf2bba01e';
exports.CLAIM_EXTENSION_721_V3_MAINNET = '0xa46f952645d4deec07a7cd98d1ec9ec888d4b61e';
exports.CLAIM_EXTENSION_1155_V3_MAINNET = '0x44e94034afce2dd3cd5eb62528f239686fc8f162';
exports.CLAIM_EXTENSION_721_V4_MAINNET = '0x7581871e1c11f85ec7f02382632b8574fad11b22';
exports.CLAIM_EXTENSION_1155_V4_MAINNET = '0xe7d3982e214f9dfd53d23a7f72851a7044072250';
exports.CLAIM_EXTENSION_721_V5_MAINNET = '0x3b8c2feb0f4953870f825df64322ec967aa26b8c';
exports.CLAIM_EXTENSION_1155_V5_MAINNET = '0xdb8d79c775452a3929b86ac5deab3e9d38e1c006';
// Claim contracts deployed via create2 have the same address on every network
// Starting V6, they will be deployed to the same address
exports.CLAIM_EXTENSION_721_V6 = '0x1eb73fee2090fb1c20105d5ba887e3c3ba14a17e';
exports.CLAIM_EXTENSION_1155_V6 = '0x04ba6cf3c5aa6d4946f5b7f7adf111012a9fac65';
exports.CLAIM_EXTENSION_721_SIGNATURE_MINTING_V1 = '0x56fe278ec785e8ae6dfb0fda0af4cc7a1b62baf1';
exports.CLAIM_EXTENSION_1155_SIGNATURE_MINTING_V1 = '0x85c71e0bde93a1719b1be9358172ad472090217c';
// Starting V7, claim contracts also contain signature mint capability
exports.CLAIM_EXTENSION_721_V7 = '0x23aa05a271debffaa3d75739af5581f744b326e4';
exports.CLAIM_EXTENSION_1155_V7 = '0x26bbea7803dcac346d5f5f135b57cf2c752a02be';
exports.CLAIM_EXTENSION_721_V8 = '0x5889e848b2423344f7969bc158100c07595c0137';
exports.CLAIM_EXTENSION_1155_V8 = '0x88438f4d4b8516e758a319ad16924da60e1e56cc';
exports.CLAIM_UPDATABLE_MINT_FEE_721_V1 = '0xe78d5842b6842056aac519e927030b6f6e80a2d6';
exports.CLAIM_UPDATABLE_MINT_FEE_1155_V1 = '0x5e90e85ff40a4bc6f3e59ce12beaeaa616f5ab86';
var Trait;
(function (Trait) {
    Trait["Airdrop"] = "airdrop";
    Trait["ClaimIndex"] = "claimIndex";
    Trait["NoSupplyReduction"] = "noReduction";
    Trait["Payable"] = "payable";
    Trait["Fee"] = "fee";
    Trait["ERC20"] = "erc20";
    Trait["DelegateMint"] = "delegateMint";
    Trait["DelegateV1"] = "delegateV1";
    Trait["DelegateV2"] = "delegateV2";
    Trait["Signature"] = "signature";
    Trait["Proxy"] = "proxy";
    Trait["UpdateTokenURIParams"] = "updateTokenUriParams";
    Trait["UpdateeMintFee"] = "updateMintFee";
    Trait["ContractVersion"] = "contractVersion";
})(Trait || (exports.Trait = Trait = {}));
var StorageProtocol;
(function (StorageProtocol) {
    StorageProtocol[StorageProtocol["INVALID"] = 0] = "INVALID";
    StorageProtocol[StorageProtocol["NONE"] = 1] = "NONE";
    StorageProtocol[StorageProtocol["ARWEAVE"] = 2] = "ARWEAVE";
    StorageProtocol[StorageProtocol["IPFS"] = 3] = "IPFS";
})(StorageProtocol || (exports.StorageProtocol = StorageProtocol = {}));
exports.addresses = [
    exports.CLAIM_EXTENSION_721_V1_MAINNET,
    exports.CLAIM_EXTENSION_1155_V1_MAINNET,
    exports.CLAIM_EXTENSION_721_V2_MAINNET,
    exports.CLAIM_EXTENSION_1155_V2_MAINNET,
    exports.CLAIM_EXTENSION_721_V3_MAINNET,
    exports.CLAIM_EXTENSION_1155_V3_MAINNET,
    exports.CLAIM_EXTENSION_721_V4_MAINNET,
    exports.CLAIM_EXTENSION_1155_V4_MAINNET,
    exports.CLAIM_EXTENSION_721_V5_MAINNET,
    exports.CLAIM_EXTENSION_1155_V5_MAINNET,
    exports.CLAIM_EXTENSION_721_V6,
    exports.CLAIM_EXTENSION_1155_V6,
    exports.CLAIM_EXTENSION_721_SIGNATURE_MINTING_V1,
    exports.CLAIM_EXTENSION_1155_SIGNATURE_MINTING_V1,
    exports.CLAIM_EXTENSION_721_V7,
    exports.CLAIM_EXTENSION_1155_V7,
    exports.CLAIM_EXTENSION_721_V8,
    exports.CLAIM_EXTENSION_1155_V8,
    exports.CLAIM_UPDATABLE_MINT_FEE_721_V1,
    exports.CLAIM_UPDATABLE_MINT_FEE_1155_V1,
];
const deployments = {
    [exports.CLAIM_EXTENSION_721_V1_MAINNET]: {
        factory: factories_1.Claim721V1__factory,
        abi: abis_1.Claim721V1ABI,
        network: frontend_provider_types_1.EthereumNetwork.MAINNET,
        type: 'erc721',
        traits: [Trait.NoSupplyReduction],
    },
    [exports.CLAIM_EXTENSION_1155_V1_MAINNET]: {
        factory: factories_1.Claim1155V1__factory,
        abi: abis_1.Claim1155V1ABI,
        network: frontend_provider_types_1.EthereumNetwork.MAINNET,
        type: 'erc1155',
        traits: [Trait.NoSupplyReduction],
    },
    [exports.CLAIM_EXTENSION_721_V2_MAINNET]: {
        factory: factories_1.Claim721V2Payable__factory,
        abi: abis_1.Claim721V2PayableABI,
        network: frontend_provider_types_1.EthereumNetwork.MAINNET,
        type: 'erc721',
        traits: [Trait.Payable, Trait.NoSupplyReduction],
    },
    [exports.CLAIM_EXTENSION_1155_V2_MAINNET]: {
        factory: factories_1.Claim1155V2Payable__factory,
        abi: abis_1.Claim1155V2PayableABI,
        network: frontend_provider_types_1.EthereumNetwork.MAINNET,
        type: 'erc1155',
        traits: [Trait.Payable, Trait.NoSupplyReduction],
    },
    [exports.CLAIM_EXTENSION_721_V3_MAINNET]: {
        factory: factories_1.Claim721V3Airdrop__factory,
        abi: abis_1.Claim721V3AirdropABI,
        network: frontend_provider_types_1.EthereumNetwork.MAINNET,
        type: 'erc721',
        traits: [
            Trait.Payable,
            Trait.Airdrop,
            Trait.ClaimIndex,
            Trait.DelegateMint,
            Trait.UpdateTokenURIParams,
            Trait.DelegateV1,
        ],
    },
    [exports.CLAIM_EXTENSION_1155_V3_MAINNET]: {
        factory: factories_1.Claim1155V3Airdrop__factory,
        abi: abis_1.Claim1155V3AirdropABI,
        network: frontend_provider_types_1.EthereumNetwork.MAINNET,
        type: 'erc1155',
        traits: [
            Trait.Payable,
            Trait.Airdrop,
            Trait.ClaimIndex,
            Trait.DelegateMint,
            Trait.UpdateTokenURIParams,
            Trait.DelegateV1,
        ],
    },
    [exports.CLAIM_EXTENSION_721_V4_MAINNET]: {
        factory: factories_1.Claim721V4Fees__factory,
        abi: abis_1.Claim721V4FeesABI,
        network: frontend_provider_types_1.EthereumNetwork.MAINNET,
        type: 'erc721',
        traits: [
            Trait.Payable,
            Trait.Airdrop,
            Trait.ClaimIndex,
            Trait.Fee,
            Trait.ERC20,
            Trait.DelegateMint,
            Trait.Proxy,
            Trait.UpdateTokenURIParams,
            Trait.DelegateV1,
        ],
    },
    [exports.CLAIM_EXTENSION_1155_V4_MAINNET]: {
        factory: factories_1.Claim1155V4Fees__factory,
        abi: abis_1.Claim1155V4FeesABI,
        network: frontend_provider_types_1.EthereumNetwork.MAINNET,
        type: 'erc1155',
        traits: [
            Trait.Payable,
            Trait.Airdrop,
            Trait.ClaimIndex,
            Trait.Fee,
            Trait.ERC20,
            Trait.DelegateMint,
            Trait.Proxy,
            Trait.UpdateTokenURIParams,
            Trait.DelegateV1,
        ],
    },
    [exports.CLAIM_EXTENSION_721_V5_MAINNET]: {
        factory: factories_1.Claim721V5Optimization__factory,
        abi: abis_1.Claim721V5OptimizationABI,
        network: frontend_provider_types_1.EthereumNetwork.MAINNET,
        type: 'erc721',
        traits: [
            Trait.Payable,
            Trait.Airdrop,
            Trait.ClaimIndex,
            Trait.Fee,
            Trait.ERC20,
            Trait.DelegateMint,
            Trait.Proxy,
            Trait.UpdateTokenURIParams,
            Trait.ContractVersion,
            Trait.DelegateV1,
        ],
    },
    [exports.CLAIM_EXTENSION_1155_V5_MAINNET]: {
        factory: factories_1.Claim1155V5Optimization__factory,
        abi: abis_1.Claim1155V5OptimizationABI,
        network: frontend_provider_types_1.EthereumNetwork.MAINNET,
        type: 'erc1155',
        traits: [
            Trait.Payable,
            Trait.Airdrop,
            Trait.ClaimIndex,
            Trait.Fee,
            Trait.ERC20,
            Trait.DelegateMint,
            Trait.Proxy,
            Trait.UpdateTokenURIParams,
            Trait.ContractVersion,
            Trait.DelegateV1,
        ],
    },
    [exports.CLAIM_EXTENSION_721_V6]: {
        factory: factories_1.Claim721V5Optimization__factory,
        abi: abis_1.Claim721V5OptimizationABI,
        type: 'erc721',
        traits: [
            Trait.Payable,
            Trait.Airdrop,
            Trait.ClaimIndex,
            Trait.Fee,
            Trait.ERC20,
            Trait.DelegateMint,
            Trait.Proxy,
            Trait.UpdateTokenURIParams,
            Trait.ContractVersion,
            Trait.DelegateV1,
        ],
    },
    [exports.CLAIM_EXTENSION_1155_V6]: {
        factory: factories_1.Claim1155V5Optimization__factory,
        abi: abis_1.Claim1155V5OptimizationABI,
        type: 'erc1155',
        traits: [
            Trait.Payable,
            Trait.Airdrop,
            Trait.ClaimIndex,
            Trait.Fee,
            Trait.ERC20,
            Trait.DelegateMint,
            Trait.Proxy,
            Trait.UpdateTokenURIParams,
            Trait.ContractVersion,
            Trait.DelegateV1,
        ],
    },
    [exports.CLAIM_EXTENSION_721_SIGNATURE_MINTING_V1]: {
        factory: factories_1.Claim721SignatureV1__factory,
        abi: abis_1.Claim721SignatureV1ABI,
        type: 'erc721',
        traits: [
            Trait.Payable,
            Trait.Airdrop,
            Trait.ClaimIndex,
            Trait.Fee,
            Trait.ERC20,
            Trait.DelegateMint,
            Trait.Signature,
            Trait.Proxy,
            Trait.UpdateTokenURIParams,
            Trait.ContractVersion,
            Trait.DelegateV1,
        ],
    },
    [exports.CLAIM_EXTENSION_1155_SIGNATURE_MINTING_V1]: {
        factory: factories_1.Claim1155SignatureV1__factory,
        abi: abis_1.Claim1155SignatureV1ABI,
        type: 'erc1155',
        traits: [
            Trait.Payable,
            Trait.Airdrop,
            Trait.ClaimIndex,
            Trait.Fee,
            Trait.ERC20,
            Trait.DelegateMint,
            Trait.Signature,
            Trait.Proxy,
            Trait.UpdateTokenURIParams,
            Trait.ContractVersion,
            Trait.DelegateV1,
        ],
    },
    [exports.CLAIM_EXTENSION_721_V7]: {
        factory: factories_1.Claim721V7__factory,
        abi: abis_1.Claim721V7ABI,
        type: 'erc721',
        traits: [
            Trait.Payable,
            Trait.Airdrop,
            Trait.ClaimIndex,
            Trait.Fee,
            Trait.ERC20,
            Trait.DelegateMint,
            Trait.Signature,
            Trait.Proxy,
            Trait.UpdateTokenURIParams,
            Trait.ContractVersion,
            Trait.DelegateV1,
            Trait.DelegateV2,
        ],
    },
    [exports.CLAIM_EXTENSION_721_V8]: {
        factory: factories_1.Claim721V7__factory,
        abi: abis_1.Claim721V7ABI,
        type: 'erc721',
        traits: [
            Trait.Payable,
            Trait.Airdrop,
            Trait.ClaimIndex,
            Trait.Fee,
            Trait.ERC20,
            Trait.DelegateMint,
            Trait.Signature,
            Trait.Proxy,
            Trait.UpdateTokenURIParams,
            Trait.ContractVersion,
            Trait.DelegateV1,
            Trait.DelegateV2,
        ],
    },
    [exports.CLAIM_EXTENSION_1155_V7]: {
        factory: factories_1.Claim1155V7__factory,
        abi: abis_1.Claim1155V7ABI,
        type: 'erc1155',
        traits: [
            Trait.Payable,
            Trait.Airdrop,
            Trait.ClaimIndex,
            Trait.Fee,
            Trait.ERC20,
            Trait.DelegateMint,
            Trait.Signature,
            Trait.Proxy,
            Trait.UpdateTokenURIParams,
            Trait.ContractVersion,
            Trait.DelegateV1,
            Trait.DelegateV2,
        ],
    },
    [exports.CLAIM_EXTENSION_1155_V8]: {
        factory: factories_1.Claim1155V7__factory,
        abi: abis_1.Claim1155V7ABI,
        type: 'erc1155',
        traits: [
            Trait.Payable,
            Trait.Airdrop,
            Trait.ClaimIndex,
            Trait.Fee,
            Trait.ERC20,
            Trait.DelegateMint,
            Trait.Signature,
            Trait.Proxy,
            Trait.UpdateTokenURIParams,
            Trait.ContractVersion,
            Trait.DelegateV1,
            Trait.DelegateV2,
        ],
    },
    [exports.CLAIM_UPDATABLE_MINT_FEE_721_V1]: {
        factory: factories_1.Claim721UpdatableMintFeeV1__factory,
        abi: abis_1.Claim721UpdatableMintFeeV1ABI,
        type: 'erc721',
        traits: [
            Trait.Payable,
            Trait.Airdrop,
            Trait.ClaimIndex,
            Trait.Fee,
            Trait.ERC20,
            Trait.DelegateMint,
            Trait.Signature,
            Trait.Proxy,
            Trait.UpdateTokenURIParams,
            Trait.UpdateeMintFee,
            Trait.ContractVersion,
            Trait.DelegateV1,
            Trait.DelegateV2,
        ],
    },
    [exports.CLAIM_UPDATABLE_MINT_FEE_1155_V1]: {
        factory: factories_1.Claim1155UpdatableMintFeeV1__factory,
        abi: abis_1.Claim1155UpdatableMintFeeV1ABI,
        type: 'erc1155',
        traits: [
            Trait.Payable,
            Trait.Airdrop,
            Trait.ClaimIndex,
            Trait.Fee,
            Trait.ERC20,
            Trait.DelegateMint,
            Trait.Signature,
            Trait.Proxy,
            Trait.UpdateTokenURIParams,
            Trait.UpdateeMintFee,
            Trait.ContractVersion,
            Trait.DelegateV1,
            Trait.DelegateV2,
        ],
    },
};
/**
 *  UTILS
 */
function is721(extension) {
    return extension.type === 'erc721';
}
exports.is721 = is721;
function is1155(extension) {
    return extension.type === 'erc721';
}
exports.is1155 = is1155;
function hasTrait(extension, trait) {
    return extension.traits.some((t) => t === trait);
}
exports.hasTrait = hasTrait;
const isKnownAddress = (address) => {
    return address.toLowerCase() in deployments;
};
exports.isKnownAddress = isKnownAddress;
function getExtension(address) {
    const _address = address.toLowerCase();
    if (!(0, exports.isKnownAddress)(_address)) {
        return null;
    }
    return deployments[_address];
}
exports.getExtension = getExtension;
function getExtensions() {
    return deployments;
}
exports.getExtensions = getExtensions;
const getExtensionsWithTrait = (trait) => {
    return Object.keys(deployments).filter((address) => {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return hasTrait(getExtension(address), trait);
    });
};
exports.getExtensionsWithTrait = getExtensionsWithTrait;
//# sourceMappingURL=claims.js.map